/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, createContext, useEffect } from 'react';
import { MODE } from 'src/libs/constants/template-mode.constant';
import { SoundServices } from 'src/libs/services/sound.service';

export type MainContextType = {
  namePage: string | '';
  setNamePage: (name: string) => void;
  tabAdminActive: string | null;
  setTabAdminActive: (tab: string) => void;
  templateMode: string | null;
  setTemplateMode: (string: string) => void;
  openConfigure: boolean;
  setOpenConfigure: (closeLink: boolean) => void;
};

export const MainContext = createContext<MainContextType | null>(null);

export const MainProvider: React.FC<React.ReactNode> = (props: any) => {
  const [namePage, setNamePage] = useState<string>('');
  const [openConfigure, setOpenConfigure] = useState<boolean>(false);
  const [tabAdminActive, setTabAdminActive] = useState<string | null>('');
  const [templateMode, setTemplateMode] = useState<string | null>(null);

  useEffect(() => {
    if (localStorage.getItem('TEMPLATE_MODE')) {
      setTemplateMode(localStorage.getItem('TEMPLATE_MODE'));
    } else {
      localStorage.setItem('TEMPLATE_MODE', MODE.Normal);
      setTemplateMode(MODE.Normal);
    }
    if (localStorage.getItem('sound') === null){
      SoundServices.turnOnSound(); // set default sound settings
    }
  }, []);

  return (
    <MainContext.Provider
      value={{
        namePage,
        setNamePage,
        tabAdminActive,
        setTabAdminActive,
        templateMode,
        setTemplateMode,
        openConfigure,
        setOpenConfigure
      }}
    >
      {props?.children || null}
    </MainContext.Provider>
  );
};
